import { render, staticRenderFns } from "./TAskSeo.vue?vue&type=template&id=0ccff51a&"
import script from "./TAskSeo.vue?vue&type=script&lang=js&"
export * from "./TAskSeo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports